import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  output,
} from '@angular/core';
import { UserLevelComponent } from '@core/components/user-level/user-level.component';
import { User } from '@core/interfaces/user.interface';
import { ClipboardService } from '@core/services/clipboard.service';
import { SvgIconComponent } from 'angular-svg-icon';

@Component({
  selector: 'app-user-common-info',
  imports: [SvgIconComponent, UserLevelComponent],
  templateUrl: './user-common-info.component.html',
  styleUrl: './user-common-info.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class UserCommonInfoComponent {
  user = input.required<User>();
  registeredDate = input<number>();
  showCopyFn = input<boolean>(false);

  logoutFn = output<void>();
  showLogout = input<boolean>(false);

  date = computed(() => {
    const registeredDate = this.registeredDate();
    if (registeredDate) {
      return new Intl.DateTimeFormat('en-US', {
        day: '2-digit',
        month: 'long',
        year: 'numeric',
      }).format(new Date(registeredDate * 1000));
    } else {
      return null;
    }
  });

  constructor(public clipboardService: ClipboardService) {}
}
